'use client';

import { cn } from '@/core/utils/cn';

interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export function Switch({ checked = false, onChange, label, description, disabled, className, id }: SwitchProps) {
  return (
    <label id={id} className={cn('flex items-center justify-between gap-3 cursor-pointer', disabled && 'opacity-50 cursor-not-allowed', className)}>
      {(label || description) && (
        <div>
          {label && <span className="text-[13px] text-hms-text">{label}</span>}
          {description && <p className="text-[11px] text-hms-textDim mt-0.5">{description}</p>}
        </div>
      )}
      {/* Unique per switch: a fixed id here gave EVERY switch on a page the
          same element id (`shared-switch-btn-1`). */}
      <button id={id ? `${id}-btn` : undefined}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange?.(!checked)}
        className={cn(
          'relative w-9 h-5 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-hms-gold/30',
          checked ? 'bg-hms-gold' : 'bg-hms-border'
        )}
      >
        <span className={cn(
          'absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform duration-200',
          checked && 'translate-x-4'
        )} />
      </button>
    </label>
  );
}
